import { Box, Toolbar, useTheme, AppBar, Button, Tooltip, useMediaQuery } from '@mui/material';
import {css} from '@emotion/css';
import React, { useEffect, useRef, useState } from 'react';
import AccountMenu from './AccountMenu';
import { Link } from 'react-router-dom';
import useAuth from './Auth';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../hooks';
import { selectMyCompany } from '../containers/accountSlice';

const PageHeader = () => {
	const theme = useTheme();
	const { t } = useTranslation();
	const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
	const classes = {
		menu: css`
        & > div {
        }
        & > div > button.MuiButton-text {
          padding: ${theme.spacing(1, 2)};
          border-radius: 0;
        }
        `,
		hideAppBar: css`
			transform: translateY(-100%);
		`
	};

	const [showHeader, setShowHeader] = useState(true);
	const lastScrollY = useRef(0);
	const ticking = useRef(false); // To throttle updates
	const threshold = 10; // Minimum scroll delta to trigger visibility toggle
	const {userProfile} = useAuth();
	const myCompany = useAppSelector(selectMyCompany);
	useEffect(() => {
		const handleScroll = () => {
			const currentScrollY = window.scrollY;

			if (!ticking.current) {
				window.requestAnimationFrame(() => {
					const scrollDelta = currentScrollY - lastScrollY.current;

					if (Math.abs(scrollDelta) > threshold || currentScrollY === 0) {
						if (scrollDelta > 0 && currentScrollY > 0) {
							// Scrolling down
							setShowHeader(false);
						} else {
							// Scrolling up
							setShowHeader(true);
						}
						lastScrollY.current = currentScrollY;
					}

					ticking.current = false;
				});
				ticking.current = true;
			}
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return <>
		<AppBar position="fixed" color='transparent' style={{backgroundImage: 'none', boxShadow: 'none', transition: '0.3s ease'}} sx={{backgroundColor: 'background.default', opacity: 0.9}} className={showHeader ? '' : classes.hideAppBar}>
			<Toolbar>
				<Box display='flex' justifyContent='end' alignItems='center' sx={{width:'100%'}} className={classes.menu}>
					<Box><Button component={Link} to='/' sx={{px: 2, py: 1}}>{t('navigation.discover')}</Button></Box>
					{/* <Box><Button component={Link} to='/categories' sx={{px: 2, py: 1}}>{t('navigation.categories')}</Button></Box> */}
					{!myCompany?.roleVendor && <Box>{userProfile ? 
						<Button component={Link} to='/saved' sx={{px: 2, py: 1}}>{t('navigation.saved')}</Button> : 
						<Tooltip 
							title={t('common.savedTooltip')} 
							placement="top"
							enterTouchDelay={0}
							leaveTouchDelay={1500}
						>
							<Button sx={{color: theme.palette.text.disabled}}>{t('navigation.saved')}</Button>
						</Tooltip>
					}
					</Box>}
					{myCompany?.roleCreator && <Box><Button component={Link} to='/plans' sx={{px: 2, py: 1}}>{t('navigation.plans')}</Button></Box>}
					{myCompany?.roleVendor && !isSmScreen && <Box><Button component={Link} to='/products' sx={{px: 2, py: 1}}>{t('navigation.products')}</Button></Box>}
					{myCompany?.roleVendor && !isSmScreen && <Box><Button component={Link} to='/build-kits' sx={{px: 2, py: 1}}>{t('navigation.quickOrders')}</Button></Box>}
					<Box flex={1} textAlign='right'>
						<AccountMenu />
					</Box>
				</Box>
			</Toolbar>
		</AppBar>
		<Toolbar />
	</>;
};

export default PageHeader;
